export enum ApprovalRequestConfiguration {
    APPROVAL_REQUEST_SETTING = 'approval-request-setting',
    APPROVAL_REQUEST_RULE = 'approval-request-rule',
    SCHEDULE_SEND_EMAIL = 'schedule-send-email'
}

export enum EmailDeliveryCycle {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY'
}

export enum DayOfWeekScheduleEmail {
    MONDAY = '1',
    TUESDAY = '2',
    WEDNESDAY = '3',
    THURSDAY = '4',
    FRIDAY = '5',
    SATURDAY = '6',
    SUNDAY = '7'
}
